<template>
    <div class='invite-tip-dialog dialog-bg'>
        <div class="invite-tip-content">
            <div class="top-text">您的邀请码已复制</div>
            <div class="invite-round">
                <div class="invite-round-item">
                    <div class="invite-num">1</div>
                    <div class="invite-text">选择好友并粘贴发送</div>
                </div>

                <div class="invite-round-item">
                    <div class="invite-num">2</div>
                    <div class="invite-text">好友复制后打开APP自动识别</div>
                </div>

                <div class="invite-round-item">
                    <div class="invite-num">3</div>
                    <div class="invite-text">助力完成，领取积分</div>
                </div>

                <div class="invite-round-item">
                    <div class="invite-num">4</div>
                    <div class="invite-text">平台新用户积分奖励更多</div>
                </div>
            </div>
            <div class="big-btn ani-scale" @click="doInvite">邀请好友赚积分</div>
            <div class="close" @click="$emit('close')"></div>
        </div>
    </div>
</template>
<script>
import { getShareText } from '@/utils/service'
export default {
    name: 'rule-dialog',
    components: {},
    props: {},
    data() {
        return {
            shareText: ''
        }
    },
    mounted() {
        this.getShareText()
        Report.click({
            value: '{"evt": "' + 5047 + '"}',
        })
    },
    methods: {
        async getShareText() {
            try {
                const res = await getShareText()
                this.shareText = res.sn
            } catch (error) {
                this.$toast(error)
                this.$emit('close')
                console.log('error', error)
            }
        },
        doInvite() {
            MgtvApi.sendToClipboard({ content: this.shareText })
            location.href = "weixin://"
            // this.$emit('close')
            // MgtvApi.shareTo({
            //     type: 'wechat', // 分享平台：wechat(微信好友), moments(微信朋友圈), weibo, qq, qzone, face2face, fantuan, sms
            //     style: '', // 分享类型 0(链接), 1(图片), 2（GIF 从2021年1月底 APP6.8.0版本开始支持）
            //     title: '', // 分享标题
            //     shareUrl: '', // 分享链接（当style为1时，这里填写分享的图片地址或base64）
            //     shareDesc: '', // 分享描述
            //     shareIcon: '', // 分享图标
            // })
        }
    },
}
</script>
<style scoped lang='less'>
.invite-tip-content {
    width: 570px;
    height: 640px;
    border-radius: 20px;
    position: relative;
    background-image: url('../../assets/ticket-bg.png');
    background-size: 100% 100%;

    .top-text {
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        height: 200px;
        line-height: 46px;
        text-align: center;
        padding-top: 80px;
    }

    .invite-round {

        padding: 20px 60px;

        .invite-round-item {
            display: flex;
            align-items: center;
            // justify-content: center;
            margin: 18px 0 0 0;

            .invite-num {
                width: 30px;
                height: 30px;
                font-size: 24px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #FFFFFF;
                background-color: #FF7D4C;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 28px;
                margin: 0px 20px;
            }

            .invite-text {
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                line-height: 46px;
            }
        }
    }
}
</style>
